"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:7.0.0'] && _();
}
catch (e) { }
